 <section id="container" >
      <!--header start-->
     <app-header></app-header>
      <!--header end-->
      <!--sidebar start-->
      
      <!--sidebar end-->
      <!--main content start-->
      <section >
          <section class="wrapper">
              <!-- page start-->
              <div class="row">
                  <div class="col-lg-12">
                      <ul class="breadcrumb">
                          <li><a href="#"><i class="fa fa-home"></i> Home</a></li>
                          <li><a href="#"> Thank You</a></li>
                           
                      </ul>
                  </div>
                  
              </div>
              <div class="row">
                  <div class="col-sm-12">
                       <!--collapse start-->
                      <div class="panel-group m-bot20" id="accordion">
                          <div class="panel panel-default">
                           
                              <div class="panel-heading">
                                  <h4 class="panel-title">
                                      <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
                                          Order Confirmation 
                                      </a>
                                  </h4>
                              </div>
                              <div id="collapseOne" class="panel-collapse collapse in">
                                  <div class="panel-body">
                                <div style="text-align: center;font-size: 24px;padding: 100px;min-height: 420px;">Your order has been submitted. Thank you!</div>
                             
                                  </div>
                              </div>
                          </div>
                         
                          
                      </div>
                      
                      <!--collapse end-->

                  </div>
                  
              </div>
              
              <!-- page end-->
          </section>
      </section>
      <!--main content end-->
      <!-- Right Slidebar start -->
     
      <!-- Right Slidebar end -->
      <!--footer start-->
      <app-footer></app-footer>
      <!--footer end-->
  </section>